// extracted by mini-css-extract-plugin
module.exports = {"root":"DoNotTrackPage_root__K6hor","title":"DoNotTrackPage_title__1aTns"};